import NotificationTypes from 'redux/notifications/types';
import request from 'utils/request';
import urls from 'utils/config';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  fetchNotificationsSuccess,
  fetchNotificationsFailure,

  fetchMoreNotificationsSuccess,
  fetchMoreNotificationsFailure,

  readNotificationSuccess,
  readNotificationFailure,

  deleteNotificationSuccess,
  deleteNotificationFailure,

  getNewNotifications,
  getNewNotificationsSuccess,
  getNewNotificationsFailure,

  openNewNotificationSuccess,
  openNewNotificationFailure,
} from 'redux/notifications/actions';
import { DEFAULT_ERROR_MESSAGE } from 'utils/constants';
import { errorNotifier, successNotifier } from 'utils/helpers';

const { API_BASE_URL } = urls || {};


function* deleteNotification({ payload: { id, data, cb } }) {
  const url = `${API_BASE_URL}/notifications/${id}`;

  const response = yield request({ method: 'delete', data, url });

  if (response.success) {
    yield put(deleteNotificationSuccess(data));
    successNotifier('Notification deleted successfully');
    cb();
  } else {
    yield put(deleteNotificationFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to delete notification');
  }
}

function* onDeleteNotification() {
  yield takeLatest(
    NotificationTypes.DELETE_NOTIFICATION,
    deleteNotification
  );
}

function* fetchNotifications({ payload: { data } }) {
  const safePageSize = data?.pageSize || 15;
  const pageNumber = data?.currentPage || 0;
  const name = data?.name || '';
  const url = `${API_BASE_URL}/notifications?name=${name}&page=${pageNumber}&size=${safePageSize}`;

  const response = yield request({ method: 'get', url });
  if (response.success) {
    yield put(fetchNotificationsSuccess(response.raw));
  } else {
    yield put(fetchNotificationsFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to fetch notifications');
  }
}

function* onFetchNotifications() {
  yield takeLatest(
    NotificationTypes.FETCH_NOTIFICATION,
    fetchNotifications
  );
}

function* fetchMoreNotifications({ payload: { data } }) {
  const safePageSize = data?.pageSize || 15;
  const pageNumber = data?.currentPage || 0;
  const url = `${API_BASE_URL}/notifications?page=${pageNumber}&size=${safePageSize}`;

  const response = yield request({ method: 'get', url });
  if (response.success) {
    yield put(fetchMoreNotificationsSuccess(response.raw));
  } else {
    yield put(fetchMoreNotificationsFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to fetch notifications');
  }
}

function* onFetchMoreNotifications() {
  yield takeLatest(
    NotificationTypes.FETCH_MORE_NOTIFICATION,
    fetchMoreNotifications
  );
}

function* readNotification({ payload: { data } }) {
  const url = `${API_BASE_URL}/notifications/${data.id}`;

  const response = yield request({
    method: 'patch',
    data: { read: !data.read },
    url
  });

  if (response.success) {
    yield put(readNotificationSuccess(data));
    yield put(getNewNotifications());
  } else {
    yield put(readNotificationFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to read notification');
  }
}

function* onReadNotification() {
  yield takeLatest(
    NotificationTypes.READ_NOTIFICATION,
    readNotification
  );
}

function* fetchNewNotifications() {
  const url = `${API_BASE_URL}/statistics/notifications`;

  const response = yield request({
    method: 'get',
    url
  });

  if (response.success) {
    yield put(getNewNotificationsSuccess(response.raw.newNotifications));
  } else {
    yield put(getNewNotificationsFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to get unread notifications');
  }
}

function* onfetchNewNotifications() {
  yield takeLatest(
    NotificationTypes.FETCH_NEW_NOTIFICATIONS,
    fetchNewNotifications
  );
}

function* openNewNotification() {
  const url = `${API_BASE_URL}/notifications/seen`;

  const response = yield request({
    method: 'post',
    url
  });

  if (response.success) {
    yield put(openNewNotificationSuccess());
  } else {
    yield put(openNewNotificationFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to read notification');
  }
}

function* onOpenNewNotification() {
  yield takeLatest(
    NotificationTypes.OPEN_NEW_NOTIFICATIONS,
    openNewNotification
  );
}


export function* notificationSagas() {
  yield all([
    call(onDeleteNotification),
    call(onReadNotification),
    call(onFetchNotifications),
    call(onFetchMoreNotifications),
    call(onfetchNewNotifications),
    call(onOpenNewNotification)
  ]);
}
